import { render, staticRenderFns } from "./NotificationsSetup.vue?vue&type=template&id=84054f1e&scoped=true"
import script from "./NotificationsSetup.vue?vue&type=script&lang=ts"
export * from "./NotificationsSetup.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsSetup.vue?vue&type=style&index=0&id=84054f1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84054f1e",
  null
  
)

export default component.exports